import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { DN90A, N100A } from '@atlaskit/theme/colors';
import { themed, useGlobalTheme } from '@atlaskit/theme/components';
import { layers } from '@atlaskit/theme/constants';
var backgroundColor = themed({
  light: "var(--ds-blanket, ".concat(N100A, ")"),
  dark: "var(--ds-blanket, ".concat(DN90A, ")")
}); // IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).

var blanketStyles = css({
  position: 'fixed',
  zIndex: layers.spotlight(),
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  transition: 'opacity 220ms'
});

/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */
var Blanket = function Blanket(props) {
  var theme = useGlobalTheme();
  return jsx("div", {
    css: blanketStyles,
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      backgroundColor: props.isTinted ? backgroundColor({
        theme: theme
      }) : 'transparent'
    })
  });
};

export default Blanket;